<style scoped>
    .term-picker{
        position: relative;
        display: inline-block;
        vertical-align: top;
    }
    .picker-cells {
        width: 241px;
        margin: 10px;
        white-space: normal;
        text-align: center;
    }
    .picker-cell{
        display: inline-block;
        vertical-align: top;
        height: 24px;
        min-width: 24px;
        line-height: 24px;
        padding: 0 5px;
        box-sizing: border-box;
        border-radius: 3px;
        cursor: pointer;
    }
    .picker-cell:hover{
        background-color: #e5e5e5;
    }
    .picker-cell-active{
        box-shadow: inset 0 0 0 1px #2b62e4;
    }
    .picker-cell-disabled, .picker-cell-disabled:hover{
        background: white;
        color: #ddd;
        cursor: default;
    }
</style>
<style>
    .term-picker-poptip .ivu-poptip-body{
        padding: 0;
    }
    .term-picker-poptip .ivu-poptip-body-content{
        max-height: none;
    }
</style>
<template>
    <div class="term-picker">
        <Poptip popper-class="term-picker-poptip" trigger="click" transfer>
            <i-input size="small" icon="md-time" :value="term_text" :placeholder="placeholder"></i-input>
            <div class="picker-drop-down" slot="content">
                <div class="ivu-date-picker-header">
                    <span class="ivu-picker-panel-icon-btn ivu-date-picker-prev-btn ivu-date-picker-prev-btn-arrow-double" @click="prevPage">
                        <i class="ivu-icon ivu-icon-ios-arrow-left"></i>
                    </span>
                    <span>{{page * page_count + 1}} - {{(page + 1) * page_count}}</span>
                    <span class="ivu-picker-panel-icon-btn ivu-date-picker-next-btn ivu-date-picker-next-btn-arrow-double" @click="nextPage">
                        <i class="ivu-icon ivu-icon-ios-arrow-right"></i>
                    </span>
                </div>
                <div class="picker-cells">
                    <div class="picker-cell"
                         :class="{'picker-cell-active': isCurCell(n), 'picker-cell-disabled': isDisabledCell(n)}"
                         v-for="n in page_count"
                         @click="selectTerm(n)">
                        {{ getTerm(n) }}
                    </div>
                </div>
            </div>
        </Poptip>
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: Number,
                'default': 1
            },
            max: {
                type: Number,
                'default': 0
            },
            size: {
                type: String,
                'default': ''
            },
            placeholder: {
                type: String,
                default: ''
            },
        },
        data(){
            return {
                page: 0,
                page_count: 50,
                term: this.value
            }
        },
        computed: {
            cur_customer(){
                return this.$store.state.cur_customer;
            },
            term_text(){
                return `第 ${this.term} 期`;
            }
        },
        watch: {
            value(){
                this.term = this.value;
                this.page = Math.floor(this.value / this.page_count);
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            prevPage(){
                if(this.page > 0){
                    this.page--;
                }
            },
            nextPage(){
                this.page++;
            },
            getTerm(n){
                return this.page * this.page_count + n;
            },
            selectTerm(n){
                if(this.isDisabledCell(n)) return;
                let term = this.getTerm(n);
                this.term = term;
                this.$emit('input', term);
                this.$emit('on-change', term);
                document.body.click();
            },
            isCurCell(n){
                let term = this.getTerm(n);
                return term === this.term;
            },
            isDisabledCell(n){
                return this.max && this.getTerm(n) > this.max;
            }
        }
    }
</script>
